var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head_img2 flex2"},[_c('img',{attrs:{"src":_vm.imgurl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }